/**
 * Deep link to a saved / shared project's results view — the destination of a
 * "View details" / "Open request" row click.
 *
 * Centralised so the near-identical project-list and shared-project row
 * components (ProfilerProjectListEntry / ProjectListEntry and the two
 * SharedProjectEntry variants) don't each re-encode the same param shape.
 *
 * @param {string} listPath - the projects / team list route for this surface
 * @param {object} params - the page's current param object (preserved as-is)
 * @param {string} projectId - the project to open
 * @param {string} selectedProjectTab - the surface's SELECTED_PROJECT_TABS.RESULTS
 * @returns {string} app path with an encoded `?params=` query
 */
export const buildProjectResultsUrl = (listPath, params, projectId, selectedProjectTab) =>
  `${listPath}?params=${encodeURIComponent(
    JSON.stringify({
      ...params,
      selectedProjectId: projectId,
      selectedProjectTab,
      selectedProjectTabPage: 1
    })
  )}`;
